module.exports = __webpack_public_path__ + "media/41.b48e68ea.mp3";